export default {
  ACTIVE: 1,
  PENDING: 2,
  INACTIVE: 40,
  INACTIVE_PENDING: 4
};
